import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const TriangleFilledExclamationIcon = _ref => {
  let {
      size = "24",
      color = "#FFB600"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M13.4723 1.34963C12.8064 0.216789 11.1982 0.216789 10.5324 1.34963L0.246939 18.8496C-0.43861 20.0161 0.384418 21.5 1.71689 21.5H22.2877C23.6202 21.5 24.4432 20.0161 23.7577 18.8496L13.4723 1.34963ZM12 6.5C12.8031 6.5 13.4307 7.19343 13.3507 7.99256L12.8246 13.2537C12.7823 13.6774 12.4258 14 12 14C11.5742 14 11.2177 13.6774 11.1754 13.2537L10.6493 7.99256C10.5693 7.19343 11.1969 6.5 12 6.5ZM12.0023 15.5C12.8307 15.5 13.5023 16.1716 13.5023 17C13.5023 17.8284 12.8307 18.5 12.0023 18.5C11.1739 18.5 10.5023 17.8284 10.5023 17C10.5023 16.1716 11.1739 15.5 12.0023 15.5Z",
    fill: color
  }));
};
export default TriangleFilledExclamationIcon;